import {lazy, Suspense} from "react";
import CircularLoader from "../../customs/loader/main";


const Main = lazy(() => import("../../components/members/allMembers/main"));

const AllMembers = () => {

    return(

        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>
      
    )
};

export default AllMembers;